import { LINE_MASTER_ELEMENTS as trans } from './translationValues';

export const lineElements = t => {
  return [
    {
      id: 299,
      type: 'image',
      categoryId: 184,
      shareType: null,
      thumbnail: '/line_dot.svg',
      name: t(`LINE_MASTER_ELEMENTS:${trans.DOTTED_LINE_LABEL.key}`, trans.DOTTED_LINE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        uiType: 'line',
        styles: {
          backgroundColor: 'transparent',
          transform:
            'translateX(222.66199999999998px) translateY(874.293px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '264.6666666666667px',
          position: 'absolute',
          height: '4.411111111111111px',
        },
        type: 'image',
        value: '/line_dot.svg',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 298,
      type: 'image',
      categoryId: 184,
      shareType: null,
      thumbnail: '/line_dash.svg',
      name: t(`LINE_MASTER_ELEMENTS:${trans.DASHED_LINE_LABEL.key}`, trans.DASHED_LINE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        uiType: 'line',
        styles: {
          backgroundColor: 'transparent',
          transform:
            'translateX(132.66199999999998px) translateY(970.293px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '264.6666666666667px',
          position: 'absolute',
          height: '4.411111111111111px',
        },
        type: 'image',
        value: '/line_dash.svg',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 297,
      type: 'image',
      categoryId: 184,
      shareType: null,
      thumbnail: '/double_line.svg',
      name: t(`LINE_MASTER_ELEMENTS:${trans.DOUBLE_LINE_LABEL.key}`, trans.DOUBLE_LINE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        uiType: 'doubleLine',
        styles: {
          backgroundColor: 'transparent',
          transform:
            'translateX(264.66239420572913px) translateY(559.2929796006945px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '300px',
          position: 'absolute',
          height: '15px',
        },
        type: 'image',
        value: '/double_line.svg',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 296,
      type: 'image',
      categoryId: 184,
      shareType: null,
      thumbnail: '/line.svg',
      name: t(`LINE_MASTER_ELEMENTS:${trans.LINE_LABEL.key}`, trans.LINE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        uiType: 'line',
        styles: {
          backgroundColor: 'transparent',
          transform:
            'translateX(264.66239420572913px) translateY(559.2929796006945px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '264.6666666666667px',
          position: 'absolute',
          height: '4.411111111111111px',
        },
        type: 'image',
        value: '/line.svg',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
  ];
};
